<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        🔍 Diagnóstico de Clientes
      </v-card-title>
      
      <v-card-text>
        <!-- Información básica -->
        <div class="mb-4">
          <h3>Estado del Sistema:</h3>
          <p><strong>Permisos:</strong> {{ canManageClients ? 'SÍ' : 'NO' }}</p>
          <p><strong>Usuario:</strong> {{ currentUserAccess }}</p>
          <p><strong>Store ID:</strong> {{ getStoreId() }}</p>
          <p><strong>Loading:</strong> {{ loading_status ? 'SÍ' : 'NO' }}</p>
        </div>

        <!-- Información de clientes -->
        <div class="mb-4">
          <h3>Clientes Cargados:</h3>
          <p><strong>Total:</strong> {{ clients.length }}</p>
          
          <div v-if="clients.length > 0">
            <h4>Lista de Clientes:</h4>
            <div v-for="(client, index) in clients" :key="index" class="mb-2">
              <v-chip small class="mr-2">{{ index + 1 }}</v-chip>
              <strong>{{ client.PartyName }}</strong> - {{ client.PartyIdentification }}
              <span v-if="client.tipo_cliente"> ({{ client.tipo_cliente }})</span>
            </div>
          </div>
          
          <div v-else>
            <p>No hay clientes cargados</p>
          </div>
        </div>

        <!-- Botones de acción -->
        <div class="mb-4">
          <v-btn 
            @click="loadAllClients" 
            :loading="loading_status"
            color="primary"
            class="mr-2"
          >
            🔄 Cargar Clientes
          </v-btn>
          
          <v-btn 
            @click="initializeClients" 
            color="success"
            class="mr-2"
          >
            🏗️ Inicializar Tabla
          </v-btn>
          
          <v-btn 
            @click="checkConsole" 
            color="info"
          >
            🔍 Ver Logs
          </v-btn>
        </div>

        <!-- Tabla simple -->
        <div v-if="clients.length > 0">
          <h3>Tabla de Clientes:</h3>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Documento</th>
                  <th>Tipo</th>
                  <th>Email</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="client in clients" :key="client.PartyIdentification">
                  <td>{{ client.PartyName }}</td>
                  <td>{{ client.PartyIdentification }}</td>
                  <td>{{ client.tipo_cliente }}</td>
                  <td>{{ client.client_email || 'N/A' }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { webserver } from "@/services/webserver.js";

export default {
  name: "ClientsDebug",

  mounted() {
    this.checkPermissions();
    if (this.canManageClients) {
      this.loadAllClients();
    }
  },

  data() {
    return {
      canManageClients: false,
      currentUserAccess: null,
      loading_status: false,
      clients: []
    };
  },

  methods: {
    checkPermissions() {
      const currentUser = this.$store?.state?.profile || window.profile;
      
      if (!currentUser) {
        this.canManageClients = false;
        return;
      }
      
      this.currentUserAccess = currentUser.user_access;
      this.canManageClients = ['ADMIN', 'POS', 'VENDEDOR'].includes(this.currentUserAccess);
    },

    getStoreId() {
      return window.profile?.store_id || 
             this.$store?.state?.profile?.store_id;
    },

    loadAllClients() {
      this.loading_status = true;
      const storeId = this.getStoreId();
      
      console.log('🔍 Store ID:', storeId);
      
      const qry = {
        store: storeId,
        search: '',
        limit: 1000
      };
      
      console.log('📤 Cargando clientes:', qry);
      
      webserver('search_clients', qry, (response) => {
        this.loading_status = false;
        console.log('📥 Respuesta:', response);
        
        if (Array.isArray(response)) {
          this.clients = response;
          console.log('✅ Clientes cargados:', response.length);
        } else {
          this.clients = [];
          console.log('❌ Error o respuesta vacía:', response);
        }
      });
    },

    initializeClients() {
      const storeId = this.getStoreId();
      
      const qry = { store: storeId };
      
      console.log('📤 Inicializando tabla:', qry);
      
      webserver('init_clients_table', qry, (response) => {
        console.log('📥 Respuesta init:', response);
      });
    },

    checkConsole() {
      console.log('🔍 Estado actual:');
      console.log('- Store ID:', this.getStoreId());
      console.log('- Permisos:', this.canManageClients);
      console.log('- Usuario:', this.currentUserAccess);
      console.log('- Clientes:', this.clients.length);
      console.log('- Loading:', this.loading_status);
    }
  }
};
</script>
